import React from 'react';
import styled from 'styled-components';
import Select from '../Select/Select';

export type IndicatorSmaControlsProps = {
  options: number[];
  value: number;
  onChange: (value: number) => void;
  label?: string;
  disabled?: boolean;
  align?: 'flex-start' | 'flex-end' | 'center';
  className?: string;
};

const Row = styled.div<{ $align: string }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $align }) => $align};
  gap: 10px;
`;

const Title = styled.span`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  height: 24px;
`;

const SmaWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  transform: translateY(-5px);

  .MuiSelect-select {
    padding-top: 9px !important;
    padding-bottom: 3px !important;
  }

  .MuiOutlinedInput-root {
    min-height: 36px !important;
  }
`;

const IndicatorSmaControls: React.FC<IndicatorSmaControlsProps> = ({
  options,
  value,
  onChange,
  label = 'SMA:',
  disabled = false,
  align = 'flex-end',
  className,
}) => {
  const handleChange = (nextValue: any) => {
    const numericValue = Number(nextValue);
    if (Number.isNaN(numericValue)) return;
    onChange(numericValue);
  };

  return (
    <Row className={className} $align={align}>
      <Title className="select-title">{label}</Title>
      <SmaWrapper className="sma-row">
        <Select
          disabled={disabled}
          options={options}
          value={value}
          onChange={handleChange}
          controlHeight={34}
          selectFontSize={15}
          selectFontWeight={400}
          selectColor="#33485e"
        />
      </SmaWrapper>
    </Row>
  );
};

export default IndicatorSmaControls;
